import React, { useState, Fragment } from 'react';
import get from 'lodash/get';
import Table from '@nintex-ux/react-core/dist/Table';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@nintex-ux/react-core/dist/Modal';
import { Button } from '@nintex-ux/react-core/dist/Button';
import formatTime from '../../utils/formatTime';

import useFetch from '../../utils/useFetch';

const History = ({ data, isLoading, error, getUrl }) => {
  const callbackResponse = useFetch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (isLoading) return 'Loading...';
  if (error) return 'Error fetching history.';

  const handleRowCommand = ({ row }) => {
    callbackResponse.get(
      getUrl('callback', { callbackResponseName: row.callbackResponseBlobName })
    );
    setIsModalOpen(true);
  };

  const renderModalContent = () => {
    const { isLoading, error, response } = callbackResponse;

    if (isLoading) return <div className="modal-content-body">Loading...</div>;
    if (error) return <div className="modal-content-body">Error fetching schedule definition.</div>;

    const parsedObject = JSON.parse(get(response, 'data.callbackResponse', '{}'));
    return <pre>{JSON.stringify(parsedObject, null, 2)}</pre>;
  };

  const processData = data => ({
    ...data,
    startTime: formatTime(data.startTime),
    endTime: formatTime(data.endTime),
    expectedExecutionTime: formatTime(data.expectedExecutionTime),
    isSuccessful: data.isSuccessful ? 'Yes' : 'No',
    callbackResponse: {
      component: 'link',
      value: 'Show',
      data: data.callbackResponseBlobName,
    },
  });

  return (
    <Fragment>
      <Table
        data={data.map(processData)}
        columns={[
          {
            title: 'Start Time',
            field: 'startTime',
          },
          {
            title: 'End Time',
            field: 'endTime',
          },
          {
            title: 'Expected Execution Time',
            field: 'expectedExecutionTime',
          },
          {
            title: 'Occurrence Count',
            field: 'occurrenceCount',
          },
          {
            title: 'Retry Count',
            field: 'retryCount',
          },
          {
            title: 'Successful',
            field: 'isSuccessful',
          },
          {
            title: 'Callback Response',
            field: 'callbackResponse',
          },
        ]}
        onRowCommand={handleRowCommand}
      />

      {isModalOpen && (
        <Modal type="input" open>
          <ModalHeader onClose={() => setIsModalOpen(false)} closeButton>
            Callback Response
          </ModalHeader>
          <ModalBody>{renderModalContent()}</ModalBody>
          <ModalFooter>
            <Button type="primary" onClick={() => setIsModalOpen(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Fragment>
  );
};

export default History;
